import React, { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import * as styles from "./MobileMenu.module.scss";

import _ from "lodash";

const MobileMenu = ({ activeClassName }) => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(limit: 2000) {
        group(field: frontmatter___categories) {
          fieldValue
          totalCount
        }
      }
    }
  `);

  const [active, setActive] = useState();
  return (
    <>
      <button
        aria-label='openClose'
        id={styles.mobileBtn}
        className={active ? styles.active : ""}
        onClick={() => setActive(!active)}
      >
        <span>&nbsp;</span>
      </button>

      <div className={active ? styles.openMenu : ""}>
        <ul className={styles.mobileNav}>
          <li>
            <Link to='/' activeClassName={activeClassName}>
              الرئيسية
            </Link>
          </li>
          <li>
            <Link to='/services' activeClassName={activeClassName}>
              خدماتنا
            </Link>
          </li>
          <li>
            <Link to='/about' activeClassName={activeClassName}>
              من نحن
            </Link>
          </li>
          <li>
            <Link to='/work' activeClassName={activeClassName}>
              أعمالنا
            </Link>
          </li>
          <li>
            <Link to='/ads' activeClassName={styles.activeNav}>
              إعلاناتنا
            </Link>
          </li>
          {/* <li data-sal="slide-down" data-sal-delay="650" data-sal-easing="ease">
            <Link to="/blog" activeClassName={activeClassName}>
              المدونة
            </Link>
          </li> */}

          <li>
            <a href={`https://en.rokkey.com`} rel='noopener noreferrer'>
              🌐 English
            </a>
          </li>
          <li>
            <Link
              className={styles.calltoAction}
              to='/contact'
              activeClassName={styles.activeNav}
            >
              احصل على استشارة
            </Link>
          </li>
        </ul>

        <ul className={styles.blogNavMobile}>
          {data.allMarkdownRemark.group.map((category) => (
            <li key={category.fieldValue}>
              <Link
                to={`/${_.kebabCase(category.fieldValue)}`}
                key={category.fieldValue}
                activeClassName={styles.activeNav}
              >
                {category.fieldValue}
                <strong> &nbsp; ({category.totalCount})</strong>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default MobileMenu;
